import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { organizationApi } from '../api/organization.api'
import { organizationKeys } from './query-keys'

export type { ProjectElementFormData, ProjectElementRecord } from '../api/organization.api'

export const useProjectElements = (projectId: string | null) =>
	useQuery({
		queryKey: organizationKeys.projectElements.list(projectId),
		queryFn: () => (projectId ? organizationApi.listProjectElements(projectId) : Promise.resolve([])),
		enabled: !!projectId,
	})

export const useCreateProjectElement = () => {
	const qc = useQueryClient()
	return useMutation({
		mutationFn: organizationApi.createProjectElement,
		onSuccess: (_data, variables) =>
			void qc.invalidateQueries({ queryKey: organizationKeys.projectElements.list(variables.projectId) }),
	})
}

export const useUpdateProjectElement = () => {
	const qc = useQueryClient()
	return useMutation({
		mutationFn: organizationApi.updateProjectElement,
		onSuccess: (_data, variables) =>
			void qc.invalidateQueries({ queryKey: organizationKeys.projectElements.list(variables.projectId) }),
	})
}

export const useDeleteProjectElement = () => {
	const qc = useQueryClient()
	return useMutation({
		mutationFn: organizationApi.deleteProjectElement,
		onSuccess: (_data, variables) =>
			void qc.invalidateQueries({ queryKey: organizationKeys.projectElements.list(variables.projectId) }),
	})
}
